import { render, staticRenderFns } from "./publishMyOrders.vue?vue&type=template&id=152b07bf&scoped=true&"
import script from "./publishMyOrders.vue?vue&type=script&lang=js&"
export * from "./publishMyOrders.vue?vue&type=script&lang=js&"
import style0 from "./publishMyOrders.vue?vue&type=style&index=0&id=152b07bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152b07bf",
  null
  
)

export default component.exports